import { type FC, type ReactNode } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { useRelayEnvironment } from 'react-relay';

import { PhoneNumberInput } from 'dibs-phone-number-input/exports/PhoneNumber';

type Props = {
    errorMessage?: ReactNode;
    isLoading?: boolean;
    onChange: ({ value, isValid }: { value: string; isValid?: boolean }) => void;
    value: string;
};

const messages = defineMessages({
    phoneNumber: {
        id: 'DealerApplicationForm.phoneLabel.placeholder',
        defaultMessage: 'Phone Number',
    },
});

const PhoneNumber: FC<Props> = ({ onChange, isLoading, errorMessage, value }) => {
    const intl = useIntl();
    return (
        <PhoneNumberInput
            flagWrapperPosition="top"
            placeholder={intl.formatMessage(messages.phoneNumber)}
            environment={useRelayEnvironment()}
            dataTn="address-phone"
            name="address-phone"
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={isLoading}
            phoneNumber={value}
        />
    );
};

export default PhoneNumber;
